import React from 'react'
import {connect} from 'react-redux'
import axios from 'axios'
import { getJsonFromUrl, formatNumberMoney } from '../../../utils'
import {avatar_list, names} from '../../../utils/avatar_list'
import AnimationItem from './AnimationItem'
import '../../../css/page/TheSecond.css'
import {encode64} from '../../../utils/base64'


class TheSecondItem extends React.Component {
    handleEnterPage() {
        // if (this.props.content.type === 'channel') {
        //     window.location = `/channel/${this.props.content.target_id}?inviter_id=${this.props.inviter_id}&autopaying=1`
        // } else if (this.props.content.type === 'lecture') {
        //     window.location = `/lecture/${this.props.content.target_id}?inviter_id=${this.props.inviter_id}&autopaying=1`
        // } else {
        //     window.location = `/`
        // }
        let link = `${this.props.content.target_url}&inviter_id=${this.props.inviter_id}`
        if (this.props.price !== 'nine') {
            if (this.props.realActiveId === 4) {
                link = `${this.props.content.target_url}&inviter_id=${this.props.inviter_id}`
            }
            if (!(this.props.selectorActiveId === this.props.realActiveId)) {
                link = `${this.props.content.target_url}&inviter_id=${this.props.inviter_id}`
            }
        }
        window.location = link
    }

    renderBottom() {
        const content = this.props.content
        if (this.props.price === 'nine') {
            return (
                <div style={{marginTop: 8}}>
                    <div style={{display: 'flex',alignItems: 'center', marginLeft: 10, position: 'relative', bottom: -1}}>
                        <div style={{display: 'flex', alignItems: 'center', position: 'relative', bottom: 0}}>
                            <img style={{width: 34, marginRight: 3}} src="https://static-1253442168.image.myqcloud.com/picture/10490565_a45c66dc7e1b7aaf905ff36927d318b3.jpg" alt=""/>
                        </div>
                            <div className="bottom__price">
                                <span>￥</span><span>{formatNumberMoney(content.limit_price).split('.')[0]}</span><span>.{formatNumberMoney(content.limit_price).split('.')[1]}</span>
                            </div>
                        </div>
                        <div className="thesecond__item-bottom">
                            <div className="bottom__btn">
                                <img src="https://static-1253442168.image.myqcloud.com/picture/10490565_cc88d939156382ca6c036add972eabfd.jpg" alt=""/>
                            </div>
                    </div>
                </div>
            )
        } else {
            if (this.props.realActiveId === 4) {
                return (
                    <div className="thesecond__item-bottom-yuan">
                        <div className="bottom__btn-yuan">
                            原价GO买
                        </div>
                    </div>
                )
            }
            if (this.props.selectorActiveId === this.props.realActiveId) {
                return (
                    <div style={{marginTop: 8}}>
                        <div style={{display: 'flex',alignItems: 'center', marginLeft: 10, position: 'relative', bottom: 0}}>
                            <div style={{display: 'flex', alignItems: 'center'}}>
                                <img style={{width: 34, marginRight: 3}} src="https://static-1253442168.image.myqcloud.com/picture/10490565_a45c66dc7e1b7aaf905ff36927d318b3.jpg" alt=""/>
                            </div>
                            <div className="bottom__price">
                                <span>￥</span><span>{formatNumberMoney(content.limit_price).split('.')[0]}</span><span>.{formatNumberMoney(content.limit_price).split('.')[1]}</span>
                            </div>
                        </div>
                        <div className="thesecond__item-bottom">
                            <div className="bottom__btn">
                                <img src="https://static-1253442168.image.myqcloud.com/picture/10490565_cc88d939156382ca6c036add972eabfd.jpg" alt=""/>
                            </div>
                        </div>
                    </div>
                )
            } else {
                return (
                    <div className="thesecond__item-bottom-yuan">
                        <div className="bottom__btn-yuan">
                            原价GO买
                        </div>
                    </div>
                )
            }
        }
    }

    hendleMask() {
        if (this.props.price === 'nine') {
            return null
        } else {
            if (this.props.realActiveId === 4) {
                return (
                    <div className="thesecond__item-banner-mask">
                        <div className="mask__text">
                            已抢完
                        </div>
                    </div>
                )
            }
            if (this.props.selectorActiveId === this.props.realActiveId) {
                return null
            } else {
                return (
                    <div className="thesecond__item-banner-mask">
                        <div className="mask__text">
                            已抢完
                        </div>
                    </div>
                )
            }
        }
    }

    render() {
        const content = this.props.content
        if (this.props.realActiveId === 0 || (this.props.selectorActiveId > this.props.realActiveId)) {
            return (
                <div className="thesecond__item-none">
                    <img
                        src="https://static-1253442168.image.myqcloud.com/picture/9482958_cd79dda98e8b24a01f3f5ee37283e0a6.jpg"
                        alt=""/>
                </div>
            )
        }
        return (
            <div className="thesecond__item" onClick={() => this.handleEnterPage()}>
                <div className="thesecond__item-banner">
                    <img
                        src={content.cover_url}
                        alt=""/>
                    {this.hendleMask()}
                </div>

                {this.props.selectorActiveId === this.props.realActiveId &&
                <div className="realMoney" style={{display: 'flex',  position: 'relative', alignItems: 'center' }}>
                    <img src="https://static-1253442168.image.myqcloud.com/picture/9485074_75a34d3783ce16b34d7de94f737559d2.jpg" alt=""/>
                    <span style={{fontSize: 12,
                    color: '#fff', width: '68.75%',
                    bottom: 0, paddingLeft: 10,    height: 20,
                    position: 'absolute',alignItems: 'center',lineHeight: '20px',
                    display: 'flex'}}>到手价 <p style={{fontSize: 14, alignItems: 'baseline',display: 'flex', lineHeight: '20px'}}><i style={{fontStyle:'normal', fontSize: 10, position: 'relative'}}>￥</i>{formatNumberMoney(content.limit_price).split('.')[0]}<span style={{fontSize: 12}}>.{formatNumberMoney(content.limit_price).split('.')[1]}</span></p></span>
                    <span style={{
                        position: 'absolute',
                        right: 0,
                        textAlign:'center',
                        width: '31.25%',
                        fontSize: 12,
                        lineHeight: '20px',
                        color: '#fff',
                        textDecoration: 'line-through'
                    }}>¥{content.price}</span>
                </div>}

                {this.props.price === 'nine' &&
                <div className="realMoney" style={{display: 'flex',  position: 'relative', alignItems: 'center' }}>
                    <img src="https://static-1253442168.image.myqcloud.com/picture/9485074_75a34d3783ce16b34d7de94f737559d2.jpg" alt=""/>
                    <span style={{fontSize: 12,
                        color: '#fff', width: '68.75%',
                        bottom: 0, paddingLeft: 10,    height: 20,
                        position: 'absolute',alignItems: 'center',lineHeight: '20px',
                        display: 'flex'}}>到手价 <p style={{fontSize: 14, alignItems: 'baseline',display: 'flex', lineHeight: '20px'}}><i style={{fontStyle:'normal', fontSize: 10, position: 'relative'}}>￥</i>{formatNumberMoney(content.limit_price).split('.')[0]}<span style={{fontSize: 12}}>.{formatNumberMoney(content.limit_price).split('.')[1]}</span></p></span>
                    <span style={{
                        position: 'absolute',
                        right: 0,
                        textAlign:'center',
                        width: '31.25%',
                        fontSize: 12,
                        lineHeight: '20px',
                        color: '#fff',
                        textDecoration: 'line-through'
                    }}>¥{content.price}</span>
                </div>}
                <div data-tags={this.props.price} className="thesecond__item-title">
                    {content.name}
                </div>
                <div className="thesecond__item-tags">
                    <div className="item__tag">
                        限时抢购
                    </div>
                    <div className="item__tag">
                        爆款
                    </div>
                </div>

                {this.renderBottom()}
            </div>
        )
    }
}

class TheSecondItemLong extends React.Component {

    handleEnterPage() {
        // if (this.props.content.type === 'channel') {
        //     window.location = `/channel/${this.props.content.target_id}?inviter_id=${this.props.inviter_id}&autopaying=1`
        // } else if (this.props.content.type === 'lecture') {
        //     window.location = `/lecture/${this.props.content.target_id}?inviter_id=${this.props.inviter_id}&autopaying=1`
        // } else {
        //     window.location = `/`
        // }
        window.location = `${this.props.content.target_url}&inviter_id=${this.props.inviter_id}`
    }

    render() {
        const content = this.props.content
        return (
            // 长条的那个类目的到手价样式
            <div className="thesecond__longitem" onClick={() => this.handleEnterPage()}>
                <div className="thesecond__item-banner">
                    <div className="realMoney" style={{position: 'absolute', bottom: 0, width: '100%'}}>
                         <div style={{
                             bottom: 0,
                             position: 'absolute',
                             left: 0,
                             width: '61.28%',
                             textAlign: 'center',
                             color: '#fff',
                             fontSize: 12,
                             display: 'flex',
                             alignItems: 'center',
                             justifyContent: 'center',
                             height: 25,
                             lineHeight: '25px'
                         }}>到手价 <p style={{fontSize: 14, alignItems: 'baseline',display: 'flex', lineHeight: '20px'}}><i style={{fontStyle:'normal', fontSize: 10, position: 'relative'}}>￥</i>{formatNumberMoney(content.limit_price).split('.')[0]}<span style={{fontSize: 12}}>.{formatNumberMoney(content.limit_price).split('.')[1]}</span></p></div>
                         <div style={{
                             position: 'absolute',
                             right: 0,
                             color: '#fff',
                             fontSize: 12,
                             textAlign: 'center',
                             width: '35%',
                             lineHeight: '25px',
                             display: 'flex',
                             alignItems: 'center',
                             justifyContent: 'center',
                             height: '100%',
                             textDecoration: 'line-through'
                         }}>原价 ¥{content.price}</div>
                        <img src="https://static-1253442168.image.myqcloud.com/picture/9485074_ad6653a0a469975e4f76ac8b53dac51b.jpg" alt=""/>
                    </div>
                    <div className="banner__topright">
                        <img
                            src="https://static-1253442168.image.myqcloud.com/picture/6163375_73501a35e2b989bf940393e5e321912f.jpg"
                            alt=""/>
                    </div>
                    <img
                        src={content.cover_url}
                        alt=""/>
                </div>
                <div className="thesecond__longitem-right">
                    <div className="thesecond__longitem-right__top">
                        <div className="thesecond__item-title">
                            {content.name}
                        </div>
                        <div className="thesecond__item-tags">
                            <div className="item__tag">
                                限时抢购
                            </div>
                            <div className="item__tag">
                                爆款
                            </div>
                        </div>
                    </div>
                    <div>
                        <div style={{display: 'flex'}}>
                            <div style={{display: 'flex', alignItems: 'center', position: 'relative', bottom: 0}}>
                                <img style={{width: 34, marginRight: 3, }} src="https://static-1253442168.image.myqcloud.com/picture/10490565_a45c66dc7e1b7aaf905ff36927d318b3.jpg" alt=""/>
                            </div>
                            <div className="bottom__price">
                                <span>￥</span><span>{formatNumberMoney(content.limit_price).split('.')[0]}</span><span>.{formatNumberMoney(content.limit_price).split('.')[1]}</span>
                                {/*<span>￥ </span><span>9</span><span>.9</span>*/}
                            </div>
                        </div>
                        <div className="thesecond__item-bottom">
                            <div className="bottom__btn">
                                <img src="https://static-1253442168.image.myqcloud.com/picture/10490565_8294ba94b0af6439dc48ee0f795b8f0d.jpg" alt=""/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


class TheSecond extends React.Component {

    constructor() {
        super()
        this.state = {
            realActiveId: 0,
            selectorActiveId: 0,
            one: null,
            nine: null,
            selectorList: null,
            selectorActiveTime: null,
            now: Date.now(),
            inviter_id: 57999322
        }
    }

    componentDidMount() {
        document.title = '一折秒杀'

        let result = getJsonFromUrl(window.location.search)
        if (result.inviter_id) {
            this.setState({
                inviter_id: result.inviter_id
            })
        }

        axios.get('/api/account/self').then((response) => {
            if(response.data.code === 0) {
                this.props.dispatch({
                    type: 'UPDATE_SHARE_DATA',
                    payload: {
                        title: `${response.data.data.nickname}邀请你参加双旦钜惠，1折狂欢GO!`,
                        desc: "1元秒杀正在进行中，更多好课限时1折，点击立抢",
                        imgUrl: `https://static-1253442168.image.myqcloud.com/picture/9482958_f057eb67947f616dcadef53334d3a61c.jpg`,
                        link: window.location.origin + window.location.pathname + '?inviter_id=57999322',
                    }
                });
            }
        })

        axios.get('/api/query_settings?module=web_second&key=activity_info')
            .then(res => {
                if (res.data.code === 0) {
                    this.setState(res.data.data, () => {
                        let now  = Date.now()
                        if (now < Date.parse('2018/12/24')) {
                            this.setState({
                                realActiveId: 0
                            }, () => this.hendleChangeSelector(1))
                        } else if (Date.parse('2018/12/24') <= now && now < Date.parse('2018/12/27')) {
                            this.setState({
                                realActiveId: 1
                            }, () => this.hendleChangeSelector(1))
                        } else if (Date.parse('2018/12/27') <= now && now < Date.parse('2018/12/30')) {
                            this.setState({
                                realActiveId: 2
                            }, () => this.hendleChangeSelector(2))
                        } else if (Date.parse('2018/12/30') <= now && now < Date.parse('2019/01/02')) {
                            this.setState({
                                realActiveId: 3
                            }, () => this.hendleChangeSelector(3))
                        } else {
                            this.setState({
                                realActiveId: 4
                            }, () => this.hendleChangeSelector(1))
                        }
                        this.handleFaker()
                    })
                }
            })

        this.timer = setInterval(() => {
            this.setState({
                now: Date.now()
            })
        }, 1000)
    }

    componentWillUnmount() {
        this.timer && clearInterval(this.timer)
    }

    handleFaker() {
        if (this.fake_animation) {
            return
        }
        let raw_list = avatar_list;
        let raw_list_name = names;
        let result = [];
        let result_name = [];

        let avatar_num = 10;

        for (let i = 0;i < avatar_num;i++){
            let random = Math.floor(Math.random() * (raw_list.length - i));
            result.push(raw_list[random]);
            raw_list[random] = raw_list[raw_list.length - i - 1];
        }
        for (let i = 0;i < avatar_num;i++){
            let random = Math.floor(Math.random() * (raw_list_name.length - i));
            result_name.push(raw_list_name[random]);
            raw_list_name[random] = raw_list_name[raw_list_name.length - i - 1];
        }

        let list = [
            {img: result[0], name: result_name[0]},
            {img: result[1], name: result_name[1]},
            {img: result[2], name: result_name[2]},
            {img: result[3], name: result_name[3]},
            {img: result[4], name: result_name[4]},
            {img: result[5], name: result_name[5]},
            {img: result[6], name: result_name[6]},
            {img: result[7], name: result_name[7]},
            {img: result[8], name: result_name[8]},
            {img: result[9], name: result_name[9]}
        ];

        let index = -1;

        this.setState({
            animation_content: list[0]
        }, () => {
            index = 0
        });

        this.fake_animation = setInterval(() => {
            if (index === 9){
                index = 0
            }else {
                index = index + 1
            }
            this.setState({
                animation_content: list[index]
            })
        }, 2300)
    }

    hendleChangeSelector(id) {
        let list = []
        let timeList = []
        
        if (id === 1 && this.state.one) {
            list = this.state.one.first
            timeList = [Date.parse('2018/12/24'), Date.parse('2018/12/27')]
        }
        if (id === 2 && this.state.one) {
            list = this.state.one.second
            timeList = [Date.parse('2018/12/27'), Date.parse('2018/12/30')]
        }
        if (id === 3 && this.state.one) {
            list = this.state.one.third
            timeList = [Date.parse('2018/12/30'), Date.parse('2019/01/02')]
        }
        this.setState({
            selectorList: list,
            selectorActiveId: id,
            selectorActiveTime: timeList
        })
    }

    ifisTimeout(endTimestamp, now) {
        if (endTimestamp - now < 0) {
            return true // 抢完
        }
    }

    handleLimitTime(beginTimestamp, endTimestamp, now) {
        let timestamp = 0
        if (endTimestamp - now === 0 || beginTimestamp === 0) {
            window.location.reload()
            return null
        }
        if (endTimestamp - now < 0) {
            return (
                <div className="thesecond__onelist-time" style={{fontSize: '16px'}}>
                    来晚了，已抢完
                </div>
            )
        }
        if (beginTimestamp > now) {
            timestamp = beginTimestamp
        }
        if (beginTimestamp < now && now < endTimestamp) {
            timestamp = endTimestamp
        }
        let offset = (timestamp - now) / 1000
        const hour = Math.floor(offset / 3600) >= 10 ? Math.floor(offset / 3600) : '0' + Math.floor(offset / 3600)
        const minute = Math.floor((offset - hour * 3600) / 60) >= 10 ? Math.floor((offset - hour * 3600) / 60) : '0' + Math.floor((offset - hour * 3600) / 60)
        const second = Math.floor((offset - hour * 3600 - minute * 60)) >= 10 ? Math.floor((offset - hour * 3600 - minute * 60)) : '0' + Math.floor((offset - hour * 3600 - minute * 60))
        if (beginTimestamp > now) {
            return (
                <div className="thesecond__onelist-time">
                    <p>{Math.floor(hour / 24)}</p>天<p>{hour % 24}</p>时<p>{minute}</p>分<p>{second}</p>秒 后开抢
                </div>
            )
        }
        if (beginTimestamp < now && now < endTimestamp) {
            return (
                <div className="thesecond__onelist-time">
                    <p>{Math.floor(hour / 24)}</p>天<p>{hour % 24}</p>时<p>{minute}</p>分<p>{second}</p>秒 后结束
                </div>
            )
        }
    }

    jumpToContent() {
        const redPacketLectureArea = this.refs.redPacketLecture.getBoundingClientRect().top
        window.scrollTo (0, redPacketLectureArea)
    }

    render() {
        const selectorActive = 'https://static-1253442168.image.myqcloud.com/picture/6163375_794e7cae7ae87415de767d56a5d75520.jpg'
        const selector = 'https://static-1253442168.image.myqcloud.com/picture/6163375_7fa61a4f9cec0afef2089950e487b2f8.jpg'

        return (
            <div className="thesecond">
                {this.state.animation_content &&
                <div className="animation__mask">
                    <AnimationItem content={this.state.animation_content}/>
                </div>
                }

                <div className="thesecond__banner">
                    <img
                        src="https://static-1253442168.image.myqcloud.com/picture/11087406_f44d1e2f72143d44c06fa710195785f0.jpg"
                        alt=""  onClick={() => this.jumpToContent()} />
                </div>

                <div className="thesecond__onetitle" onClick={() => this.jumpToContent()}>
                    <img
                        src="https://static-1253442168.image.myqcloud.com/picture/10490565_dd3c188a21b148132b00fce5828416ad.jpg"
                        alt=""/>
                </div>

                <div className="thesecond__onelist">
                    <div className="thesecond__onelist-selector">
                        <div onClick={() => this.hendleChangeSelector(1)} className={this.state.selectorActiveId === 1 ? 'selector__item selector__item-active' : 'selector__item'} style={{backgroundImage: `url(${this.state.selectorActiveId === 1 ? selectorActive : selector})`}}>
                            <span style={{left: 4, position: 'relative'}}>{this.state.realActiveId === 1 ? '正在疯抢' : '12.24至12.26'}</span>
                        </div>
                        <div onClick={() => this.hendleChangeSelector(2)} className={this.state.selectorActiveId === 2 ? 'selector__item selector__item-active' : 'selector__item'} style={{backgroundImage: `url(${this.state.selectorActiveId === 2 ? selectorActive : selector})`}}>
                            <span style={{left: 4, position: 'relative'}}>{this.state.realActiveId === 2 ? '正在疯抢' : '12.27至12.29'}</span>
                        </div>
                        <div onClick={() => this.hendleChangeSelector(3)} className={this.state.selectorActiveId === 3 ? 'selector__item selector__item-active' : 'selector__item'} style={{backgroundImage: `url(${this.state.selectorActiveId === 3 ? selectorActive : selector})`}}>
                            <span style={{left: 4, position: 'relative'}}>{this.state.realActiveId === 3 ? '正在疯抢' : '12.30至1.1'}</span>
                        </div>
                    </div>

                    {this.state.selectorActiveTime && this.handleLimitTime(this.state.selectorActiveTime[0], this.state.selectorActiveTime[1], this.state.now)}

                    <div className="thesecond__onelist-content"  ref="redPacketLecture">
                        {this.state.selectorList && this.state.selectorList.map((item, index) => <TheSecondItem price="one" selectorActiveId={this.state.selectorActiveId} inviter_id={this.state.inviter_id} realActiveId={this.state.realActiveId} content={item} key={'one__' + index}/>)}
                    </div>
                </div>

                {this.state.nine &&
                <div className="thesecond__ninetitle">
                    <img
                        src="https://static-1253442168.image.myqcloud.com/picture/10490565_b60bbf43deb1d119f30d25e050743661.jpg"
                        alt=""/>
                </div>
                }

                {this.state.nine &&
                <div className="thesecond__ninelist">
                    <div className="thesecond__ninelist-banner">
                        <p>高质量课程 限时抢购 先到先得</p>
                    </div>
                    <div className="thesecond__ninelist-content">
                        <TheSecondItemLong content={this.state.nine[0]} inviter_id={this.state.inviter_id}/>
                        {this.state.nine && this.state.nine.slice(1).map((item, index) => <TheSecondItem price="nine" selectorActiveId={this.state.selectorActiveId} inviter_id={this.state.inviter_id} content={item} key={'nine__' + index}/>)}
                    </div>
                </div>
                }

            </div>
        )
    }
}

export default connect(state => ({

}))(TheSecond)



// WEBPACK FOOTER //
// ./src/pages/ActivityPage/TheSecond/TheSecond.js